import type { TOC } from '@ember/component/template-only'
import type RexDashboardStudentBooksReadIndexRoute from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/books-read/index/route'
import RouteTemplate from 'ember-route-template'
import { DashboardStudentBooksReadPage } from 'teacher-ui-client/components/page/reporting/reading-eggspress/dashboard/student/books-read'

interface Signature {
  Args: { model: ModelFor<RexDashboardStudentBooksReadIndexRoute> }
}

export const DashboardStudentBooksReadIndexPage: TOC<Signature> = <template>
  <DashboardStudentBooksReadPage
    @fetchBooksReadOverviewReportTask={{@model.fetchBooksReadOverviewReportTask}}
    @fetchBooksReadEventsReportTask={{@model.fetchBooksReadEventsReportTask}}
  />
</template>

export default RouteTemplate(DashboardStudentBooksReadIndexPage)
